module.exports = __webpack_public_path__ + "img/we.e7469375.png";